// src/app/services/coilApi.ts
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './apiConfig';
import { ICoil, ICoilParams, IIdNameValue, UpdatePayload } from '../models';

export const coilApi = createApi({
  reducerPath: 'coilApi',
  baseQuery,
  endpoints: (builder) => ({
    getCoilParams: builder.query<{ coil: ICoilParams }, void>({
      query: () => `/api/v1.0/cms/1/v1.0.0/ahu/coils/params/`,
      keepUnusedDataFor: Infinity, // Keep the cached data until the page reloads
    }),
    getCoil: builder.query<ICoil, number>({
      query: (id) => `/api/v1.0/ahu/coils/${id}`,
    }),
    getRatedCoil: builder.query<ICoil, number>({
      query: (id) => `/api/v1.0/ahu/rating_mode_coils/${id}`,
    }),
    getFluids: builder.query<
      IIdNameValue[],
      { type_id: number; duty_id: number; mfg_id: number }
    >({
      query: ({ type_id, duty_id, mfg_id }) =>
        `/api/v1.0/master/v1.0.0/ahu/fluids/types/${type_id}/duties/${duty_id}/?mfg_id=${mfg_id}`,
      extraOptions: {
        cacheData: true,
      },
    }),
    getConnectionDiameters: builder.query<
      IIdNameValue[],
      { type_id: number; mfg_id: number }
    >({
      query: ({ type_id, mfg_id }) =>
        `/api/v1.0/master/v1.0.0/ahu/coils/connection_diameters/mfgs/${mfg_id}/types/${type_id}/`,
      extraOptions: {
        cacheData: true,
      },
    }),
    getCoilFpis: builder.query<
      IIdNameValue[],
      { type_id: number; mfg_id: number }
    >({
      query: ({ type_id, mfg_id }) =>
        `/api/v1.0/master/v1.0.0/ahu/coils/fpis/mfgs/${mfg_id}/types/${type_id}/`,
      extraOptions: {
        cacheData: true,
      },
    }),
    createCoil: builder.mutation<any, UpdatePayload<any>>({
      query: ({ body, signal }) => ({
        url: `/api/v1.0/ahu/coils/`,
        method: 'POST',
        body,
        signal,
      }),
    }),
    updateCoil: builder.mutation<any, UpdatePayload<any>>({
      query: ({ body, signal }) => ({
        url: `/api/v1.0/ahu/coils/${body?.id}`,
        method: 'PATCH',
        body,
        signal,
      }),
    }),
    updateRatingModeCoil: builder.mutation<any, UpdatePayload<any>>({
      query: ({ body, signal }) => ({
        url: `/api/v1.0/ahu/rating_mode_coils/${body?.id}`,
        method: 'PATCH',
        body,
        signal,
      }),
    }),
  }),
});

export const {
  useLazyGetCoilQuery,
  useLazyGetRatedCoilQuery,
  useGetFluidsQuery,
  useGetConnectionDiametersQuery,
  useGetCoilFpisQuery,
  useGetCoilParamsQuery,
  useCreateCoilMutation,
} = coilApi;
